<div class="ui-procedures">
    <div class="ui-procedures-header"></div>

    <div class="ui-procedures-body">
        <app-procedures-buttons></app-procedures-buttons>
        
        <div class="ui-procedures-content">
            <app-procedures-list></app-procedures-list>
        </div>
    </div>
</div>